import styles from './notification-alert.module.scss';

import React, { useEffect } from 'react';
import { Status, AppData } from '@breakroom-nx/helpers';
import { closeModal, useAppDispatch } from '@breakroom-nx/redux';

import { Image } from 'expo-image';
import {
  Alert as AlertNative,
  Box,
  CloseIcon,
  Collapse,
  HStack,
  IconButton,
  Text,
  VStack,
} from 'native-base';

// Assets & Helpers
import iconImage from '../../../../assets/src/images/icon.webp';
import { theme } from '@breakroom-nx/assets';

/* eslint-disable-next-line */
export interface NotificationAlertProps {
  title: String;
  description: String;
}

export const NotificationAlert = ({
  title,
  description,
}: NotificationAlertProps) => {
  const [showing, setShowingState] = React.useState(true);
  const dispatch = useAppDispatch();

  // useEffect(() => {
  //   if (showing) {
  //     const timeout = setTimeout(() => setShowingState(false), 5000);
  //     return () => {
  //       clearTimeout(timeout);
  //     };
  //   } else {
  //     return;
  //   }
  // }, []);

  return (
    <Box
      maxW={'350px'}
      alignSelf="end"
      position="absolute"
      top={5}
      right={5}
      zIndex={9999}
    >
      <Collapse
        isOpen={showing}
        onAnimationEnd={() => {
          dispatch(closeModal());
        }}
      >
        <AlertNative
          w="100%"
          colorScheme={'coolGray'}
          variant="left-accent"
          backgroundColor={theme.colors.surface[400]}
        >
          <HStack space={2} alignItems={'start'}>
            <Image
              source={{ uri: iconImage }}
              cachePolicy={'memory-disk'}
              accessibilityLabel={`${AppData.APP_NAME} icon`}
              contentFit={'contain'}
              style={{
                width: '30px',
                aspectRatio: 1,
              }}
            />
            <VStack space={2} flexDir={'column'} flex={1}>
              <Text
                fontSize="xl"
                lineHeight={30}
                color="white"
                fontFamily="body"
                fontStyle="normal"
                fontWeight={600}
              >
                {title}
              </Text>

              {description ? (
                <Text
                  flex={1}
                  flexWrap={'wrap'}
                  fontSize="md"
                  color={theme.colors.surface[700]}
                  fontFamily="body"
                  fontStyle="normal"
                  fontWeight={300}
                  lineHeight="18"
                >
                  {description}
                </Text>
              ) : null}
            </VStack>
          </HStack>
        </AlertNative>
      </Collapse>
    </Box>
  );
};
